export class FetchPharmOrders {
  static readonly type = '[PharmOrders] Fetch Pharm Orders';
}
export class SetSelectedEnterpriseOrderId {
  static readonly type = '[PharmOrders] Set Selected Pharm Order';
  constructor(public enterpriseOrderId: string) {}
}
